import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full rounded-none border-2 border-ink bg-parchment px-4 py-3 text-base font-bold uppercase tracking-widest ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-black file:text-ink placeholder:text-ink/30 focus-visible:outline-none focus-visible:ring-0 focus-visible:border-terracotta disabled:cursor-not-allowed disabled:opacity-50 md:text-sm transition-colors",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
